const styles = () => ({
  nav: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: 20,
  },
});

export default styles;
